import React from "react";
import { Card } from "reactstrap";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import { Typography } from "@mui/material";
import paymentCategoryLogoDictionary from "../../paymentCategoryLogoDictionary";
import "./gatewayStyle.css";

function PaymentMethods({
  type,
  typeTitle,
  count,
  toggle,
  setToggle,
  selects,
}) {
  const handleClick = () => {
    setToggle(!toggle);
  };
  return (
    <div className="previewHeader">
      <div
        className="categoryHeader"
        onClick={handleClick}
      >
        <div style={{ flexDirection: "column" }}>
          <div style={{ display: "flex" }}>
            <img src={paymentCategoryLogoDictionary[type]?.logoColored} />
            <Typography className="pspHeader">{typeTitle}</Typography>
          </div>
          <Typography
            className="pspSubHeader"
          >
            {" "}
            {count} selected{" "}
          </Typography>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              marginRight: "10px",
            }}
          >
            <Typography className="pspSubHeader">{toggle ? "See Less" : "See More"}</Typography>
            <img
              style={{ height: "10px", width: "10px" }}
              src={toggle ? "/upArrow.png" : "/downArrow.png"}
            />
          </div>
        </div>
      </div>
      {toggle && (
        <div
         className="methodsHeader"
        >
          {selects?.map((obj) => (
            <Card
              className="cardSize"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <img
                    src={obj.logoUrl}
                    style={{ height: "38px", width: "35px" }}
                  />

                  <Typography
                    className="cardTitle"
                  >
                    {obj?.title ? (
                      <HoverToDisplayFullTitle title={obj?.title} len={20} />
                    ) : (
                      <></>
                    )}
                  </Typography>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}

export default PaymentMethods;
